import { http } from 'vue'

export default {
  loadTransports (context, params = {}) {
    return http.get('transports' + '?company_id=' + params.companyId + '&city_id=' + params.cityId)
  },
  putTransports (context, params = {}) {
    return http.put('transports/' + params.companyId + '?company_id=' + params.companyId, params.data)
  },
  loadTransport (context, params = {}) {
    return http.get('dashboard/transport' + '?company_id=' + params.companyId + '&product_id=' + params.productId + '&neighborhood_id=' + params.neighborhoodId)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/transports/actions.js